declare var dataLayer: any[];
import ProductHelper = require('../../Shared/ProductHelper');
import ICart = CheckoutflowReponse.ICart;
import ILineItem = CheckoutflowReponse.ILineItem;
import { formatPrice2Digits } from '../../Shared/PriceHelper';
import { getProductNetPrice } from './checkoutTrackingHelper';
declare var dataLayer: any[];
declare var __ucCmp: any;

/**
 * führt den dataLayer-Push im Step 2 des Checkouts durch.
 * Für Warenkorb-onload
 * @param lineItems
 */
export async function onloadTracking(cart: ICart): Promise<void> {
    if (window['__ucCmp'] !== undefined && (await __ucCmp.isInitialized())) {
        let lineItems = cart ? cart.lineItems : [];
        let products = [];
        let productIds = [];
        let productPrices = [];
        for (let lineItem of lineItems) {
            let product = lineItem.product;
            productIds.push(product.productId);
            let productNetPrice = lineItem.singleItemNetPrice
                ? formatPrice2Digits(getProductNetPrice(lineItem), true)
                : '';
            productPrices.push(productNetPrice);
            let breadcrumb: string = await ProductHelper.getBreadcrumbByTocId(product.mainTocNodeId);
            products.push({
                name: product.titleMain,
                id: product.productId,
                price: productNetPrice,
                brand: product.publisher ? product.publisher.publisherName : '',
                category: breadcrumb ? breadcrumb : '',
                variant: product.mediaType ? product.mediaType.mediaTypeName : '',
                quantity: lineItem.quantity,
                dimension8: product.displayFormat,
            });
        }

        dataLayer.push({
            pageTitle: 'Anmeldung, Registrierung, Gastbestellung',
            event: 'eec.checkoutStep',
            ecommerce: {
                checkout: {
                    actionField: { step: 2 },
                    products: products,
                },
            },
        });
    } else {
        setTimeout(onloadTracking.bind(null, cart), 100);
    }
}
